export enum AnalyticsEvent {
  USER_LOGGED_IN = "Trivia - User Logged In",
  GAME_RESTARTED = "Trivia - Game Restarted",
  LEVEL_RESET = "Trivia - Level Reset",
  LEVEL_STARTED = "Trivia - Level Started",
  LEVEL_COMPLETED = "Trivia - Level Completed",
  ANSWER_SUBMITTED = "Trivia - Answer Submitted",
  LEADERBOARD_POSITION = "Trivia - Leaderboard Position",
  LEADERBOARD_VIEWED = "Trivia - Leaderboard Viewed",
  GAME_COMPLETED = "Trivia - Game Completed",
  ERROR_BOUNDARY_DISPLAYED = "Trivia - Error Boundary Displayed",
  REFERRAL_LINK_SHARED = "Trivia - Referral Link Shared",
  REFFERAL_BANNER_VIEWED = "Trivia - Referral Banner Viewed",
  BUTTON_CLICKED = "Trivia - Button Clicked",
}
